var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpperArms(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "74px",
    height: "68px",
    viewBox: "0 0 82 68",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Upper Arms") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Homunculus",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    fillOpacity: 0.195858829
  }, /*#__PURE__*/React.createElement("g", {
    id: "Homunculus--Both-Filled",
    transform: "translate(-175.000000, -94.000000)",
    fill: "#D2D9E8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Front-Body---Selections",
    transform: "translate(175.074098, 42.681852)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5698894,51.7420815 L17.6329017,89.585243 L12.9465318,119.318148 L0.383270864,119.318148 L3.43689129,94.3515354 L5.27734329,67.3181483 C5.95865895,61.7919667 6.96249644,58.0988037 8.28885574,56.2386591 C9.61521504,54.3785146 12.0422263,52.8796554 15.5698894,51.7420815 Z M65.9462831,51.7420815 C69.4739463,52.8796554 71.9009575,54.3785146 73.2273168,56.2386591 C74.5536761,58.0988037 75.5575136,61.7919667 76.2388292,67.3181483 L76.2388292,67.3181483 L78.0792812,94.3515354 L81.1329017,119.318148 L68.5696407,119.318148 L63.8832709,89.585243 Z",
    id: "Upper-Arms"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpperArms);
export default __webpack_public_path__ + "static/media/UpperArms.2ae5eac0c2320b8141620eb4578baee4.svg";
export { ForwardRef as ReactComponent };